import { Trans, useTranslation } from "react-i18next";
import "./Footer.css";

function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <>
      <div className="w-full h-fit bg-green-600 z-50 p-6 font-[ Open Sans,sans-serif ] text-[20px] text-left font-light">
        <div>
          <span>
            <Trans i18nKey="footer.appreciation">
              Made possible by the collectives and free labor of De Grote Broek
              ❤️
            </Trans>
          </span>
        </div>
        <div>
          <span>
            <Trans i18nKey="footer.info">
              De Grote Broek - 024-3605208 - van Broeckhuysenstraat 46 / Tweede
              Walstraat 19 te Nijmegen
            </Trans>
          </span>
        </div>
        <div>
          <span>
            <a
              href="https://0xacab.org/wntrs/grotebroek-web"
              className="font-semibold underline"
            >
              Open Source
            </a>
          </span>
        </div>
      </div>
    </>
  );
}

export default Footer;
